// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file sprite_geometry.proto (package protosprite, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file sprite_geometry.proto.
 */
export const file_sprite_geometry: GenFile = /*@__PURE__*/
  fileDesc("ChVzcHJpdGVfZ2VvbWV0cnkucHJvdG8SC3Byb3Rvc3ByaXRlIhwKBFZlYzISCQoBeBgBIAEoAhIJCgF5GAIgASgCIi4KB1BvbHlnb24SIwoIdmVydGljZXMYASADKAsyES5wcm90b3Nwcml0ZS5WZWMyIj8KE0NvbnZleERlY29tcG9zaXRpb24SKAoKY29tcG9uZW50cxgBIAMoCzIULnByb3Rvc3ByaXRlLlBvbHlnb24iKAoOSW5kZXhlZFBvbHlnb24SFgoOdmVydGV4X2luZGljZXMYASADKAUihAEKDlNoYXBlUG9vbEVudHJ5EiwKB3BvbHlnb24YASABKAsyGy5wcm90b3Nwcml0ZS5JbmRleGVkUG9seWdvbhJECh9jb252ZXhfZGVjb21wb3NpdGlvbl9jb21wb25lbnRzGAIgAygLMhsucHJvdG9zcHJpdGUuSW5kZXhlZFBvbHlnb24iQAoSRnJhbWVMYXllckdlb21ldHJ5EhMKC2xheWVyX2luZGV4GAEgASgFEhUKDXNoYXBlX2luZGljZXMYBCADKAUiLwoWQ29tcG9zaXRlRnJhbWVHZW9tZXRyeRIVCg1zaGFwZV9pbmRpY2VzGAMgAygFIo0BCg1GcmFtZUdlb21ldHJ5EhMKC2ZyYW1lX2luZGV4GAEgASgFEi8KBmxheWVycxgCIAMoCzIfLnByb3Rvc3ByaXRlLkZyYW1lTGF5ZXJHZW9tZXRyeRI2Cgljb21wb3NpdGUYAyABKAsyIy5wcm90b3Nwcml0ZS5Db21wb3NpdGVGcmFtZUdlb21ldHJ5IssBChNTcHJpdGVHZW9tZXRyeUVudHJ5EhMKC3Nwcml0ZV9uYW1lGAEgASgJEioKBmZyYW1lcxgCIAMoCzIaLnByb3Rvc3ByaXRlLkZyYW1lR2VvbWV0cnkSGgoSc2ltcGxpZnlfdG9sZXJhbmNlGAMgASgCEi8KCnNoYXBlX3Bvb2wYBCADKAsyGy5wcm90b3Nwcml0ZS5TaGFwZVBvb2xFbnRyeRImCgt2ZXJ0ZXhfcG9vbBgFIAMoCzIRLnByb3Rvc3ByaXRlLlZlYzIipQEKDlNwcml0ZUdlb21ldHJ5EjEKB2VudHJpZXMYASADKAsyIC5wcm90b3Nwcml0ZS5TcHJpdGVHZW9tZXRyeUVudHJ5EhYKDGVtYmVkZGVkX3BycxgCIAEoDEgAEhsKEWV4dGVybmFsX3Byc19maWxlGAMgASgJSAASGgoQZXh0ZXJuYWxfcHJzX3VybBgEIAEoCUgAQg8KDXNwcml0ZV9zb3VyY2ViBnByb3RvMw");

/**
 * A 2D point with float precision (polygon vertices need sub-pixel accuracy
 * after simplification).
 *
 * @generated from message protosprite.Vec2
 */
export type Vec2 = Message<"protosprite.Vec2"> & {
  /**
   * @generated from field: float x = 1;
   */
  x: number;

  /**
   * @generated from field: float y = 2;
   */
  y: number;
};

/**
 * A 2D point with float precision (polygon vertices need sub-pixel accuracy
 * after simplification).
 *
 * @generated from message protosprite.Vec2
 */
export type Vec2Json = {
  /**
   * @generated from field: float x = 1;
   */
  x?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: float y = 2;
   */
  y?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message protosprite.Vec2.
 * Use `create(Vec2Schema)` to create a new message.
 */
export const Vec2Schema: GenMessage<Vec2, {jsonType: Vec2Json}> = /*@__PURE__*/
  messageDesc(file_sprite_geometry, 0);

/**
 * A single closed polygon (ordered ring of vertices).
 *
 * @generated from message protosprite.Polygon
 */
export type Polygon = Message<"protosprite.Polygon"> & {
  /**
   * @generated from field: repeated protosprite.Vec2 vertices = 1;
   */
  vertices: Vec2[];
};

/**
 * A single closed polygon (ordered ring of vertices).
 *
 * @generated from message protosprite.Polygon
 */
export type PolygonJson = {
  /**
   * @generated from field: repeated protosprite.Vec2 vertices = 1;
   */
  vertices?: Vec2Json[];
};

/**
 * Describes the message protosprite.Polygon.
 * Use `create(PolygonSchema)` to create a new message.
 */
export const PolygonSchema: GenMessage<Polygon, {jsonType: PolygonJson}> = /*@__PURE__*/
  messageDesc(file_sprite_geometry, 1);

/**
 * Convex decomposition of a polygon into convex parts.
 *
 * @generated from message protosprite.ConvexDecomposition
 */
export type ConvexDecomposition = Message<"protosprite.ConvexDecomposition"> & {
  /**
   * @generated from field: repeated protosprite.Polygon components = 1;
   */
  components: Polygon[];
};

/**
 * Convex decomposition of a polygon into convex parts.
 *
 * @generated from message protosprite.ConvexDecomposition
 */
export type ConvexDecompositionJson = {
  /**
   * @generated from field: repeated protosprite.Polygon components = 1;
   */
  components?: PolygonJson[];
};

/**
 * Describes the message protosprite.ConvexDecomposition.
 * Use `create(ConvexDecompositionSchema)` to create a new message.
 */
export const ConvexDecompositionSchema: GenMessage<ConvexDecomposition, {jsonType: ConvexDecompositionJson}> = /*@__PURE__*/
  messageDesc(file_sprite_geometry, 2);

/**
 * A polygon represented as indices into a vertex pool.
 *
 * @generated from message protosprite.IndexedPolygon
 */
export type IndexedPolygon = Message<"protosprite.IndexedPolygon"> & {
  /**
   * @generated from field: repeated int32 vertex_indices = 1;
   */
  vertexIndices: number[];
};

/**
 * A polygon represented as indices into a vertex pool.
 *
 * @generated from message protosprite.IndexedPolygon
 */
export type IndexedPolygonJson = {
  /**
   * @generated from field: repeated int32 vertex_indices = 1;
   */
  vertexIndices?: number[];
};

/**
 * Describes the message protosprite.IndexedPolygon.
 * Use `create(IndexedPolygonSchema)` to create a new message.
 */
export const IndexedPolygonSchema: GenMessage<IndexedPolygon, {jsonType: IndexedPolygonJson}> = /*@__PURE__*/
  messageDesc(file_sprite_geometry, 3);

/**
 * A de-duplicated (polygon, convex decomposition) pair stored in the shape pool.
 * Vertices are referenced by index into the parent SpriteGeometryEntry.vertex_pool.
 *
 * @generated from message protosprite.ShapePoolEntry
 */
export type ShapePoolEntry = Message<"protosprite.ShapePoolEntry"> & {
  /**
   * @generated from field: protosprite.IndexedPolygon polygon = 1;
   */
  polygon?: IndexedPolygon;

  /**
   * @generated from field: repeated protosprite.IndexedPolygon convex_decomposition_components = 2;
   */
  convexDecompositionComponents: IndexedPolygon[];
};

/**
 * A de-duplicated (polygon, convex decomposition) pair stored in the shape pool.
 * Vertices are referenced by index into the parent SpriteGeometryEntry.vertex_pool.
 *
 * @generated from message protosprite.ShapePoolEntry
 */
export type ShapePoolEntryJson = {
  /**
   * @generated from field: protosprite.IndexedPolygon polygon = 1;
   */
  polygon?: IndexedPolygonJson;

  /**
   * @generated from field: repeated protosprite.IndexedPolygon convex_decomposition_components = 2;
   */
  convexDecompositionComponents?: IndexedPolygonJson[];
};

/**
 * Describes the message protosprite.ShapePoolEntry.
 * Use `create(ShapePoolEntrySchema)` to create a new message.
 */
export const ShapePoolEntrySchema: GenMessage<ShapePoolEntry, {jsonType: ShapePoolEntryJson}> = /*@__PURE__*/
  messageDesc(file_sprite_geometry, 4);

/**
 * Traced geometry for one layer within one frame.
 *
 * @generated from message protosprite.FrameLayerGeometry
 */
export type FrameLayerGeometry = Message<"protosprite.FrameLayerGeometry"> & {
  /**
   * @generated from field: int32 layer_index = 1;
   */
  layerIndex: number;

  /**
   * Fields 2 and 3 removed (previously polygons / convex_decompositions).
   * Indices into the parent SpriteGeometryEntry.shape_pool.
   *
   * @generated from field: repeated int32 shape_indices = 4;
   */
  shapeIndices: number[];
};

/**
 * Traced geometry for one layer within one frame.
 *
 * @generated from message protosprite.FrameLayerGeometry
 */
export type FrameLayerGeometryJson = {
  /**
   * @generated from field: int32 layer_index = 1;
   */
  layerIndex?: number;

  /**
   * Fields 2 and 3 removed (previously polygons / convex_decompositions).
   * Indices into the parent SpriteGeometryEntry.shape_pool.
   *
   * @generated from field: repeated int32 shape_indices = 4;
   */
  shapeIndices?: number[];
};

/**
 * Describes the message protosprite.FrameLayerGeometry.
 * Use `create(FrameLayerGeometrySchema)` to create a new message.
 */
export const FrameLayerGeometrySchema: GenMessage<FrameLayerGeometry, {jsonType: FrameLayerGeometryJson}> = /*@__PURE__*/
  messageDesc(file_sprite_geometry, 5);

/**
 * Composite geometry for the entire frame (all layers flattened).
 * Generated on demand as an alternative to per-layer geometry.
 *
 * @generated from message protosprite.CompositeFrameGeometry
 */
export type CompositeFrameGeometry = Message<"protosprite.CompositeFrameGeometry"> & {
  /**
   * Fields 1 and 2 removed (previously polygons / convex_decompositions).
   * Indices into the parent SpriteGeometryEntry.shape_pool.
   *
   * @generated from field: repeated int32 shape_indices = 3;
   */
  shapeIndices: number[];
};

/**
 * Composite geometry for the entire frame (all layers flattened).
 * Generated on demand as an alternative to per-layer geometry.
 *
 * @generated from message protosprite.CompositeFrameGeometry
 */
export type CompositeFrameGeometryJson = {
  /**
   * Fields 1 and 2 removed (previously polygons / convex_decompositions).
   * Indices into the parent SpriteGeometryEntry.shape_pool.
   *
   * @generated from field: repeated int32 shape_indices = 3;
   */
  shapeIndices?: number[];
};

/**
 * Describes the message protosprite.CompositeFrameGeometry.
 * Use `create(CompositeFrameGeometrySchema)` to create a new message.
 */
export const CompositeFrameGeometrySchema: GenMessage<CompositeFrameGeometry, {jsonType: CompositeFrameGeometryJson}> = /*@__PURE__*/
  messageDesc(file_sprite_geometry, 6);

/**
 * Geometry for an entire frame.
 *
 * @generated from message protosprite.FrameGeometry
 */
export type FrameGeometry = Message<"protosprite.FrameGeometry"> & {
  /**
   * @generated from field: int32 frame_index = 1;
   */
  frameIndex: number;

  /**
   * @generated from field: repeated protosprite.FrameLayerGeometry layers = 2;
   */
  layers: FrameLayerGeometry[];

  /**
   * Optional: unified polygon traced from the fully composited frame
   * (all layers flattened). Present only when composite tracing is requested.
   *
   * @generated from field: protosprite.CompositeFrameGeometry composite = 3;
   */
  composite?: CompositeFrameGeometry;
};

/**
 * Geometry for an entire frame.
 *
 * @generated from message protosprite.FrameGeometry
 */
export type FrameGeometryJson = {
  /**
   * @generated from field: int32 frame_index = 1;
   */
  frameIndex?: number;

  /**
   * @generated from field: repeated protosprite.FrameLayerGeometry layers = 2;
   */
  layers?: FrameLayerGeometryJson[];

  /**
   * Optional: unified polygon traced from the fully composited frame
   * (all layers flattened). Present only when composite tracing is requested.
   *
   * @generated from field: protosprite.CompositeFrameGeometry composite = 3;
   */
  composite?: CompositeFrameGeometryJson;
};

/**
 * Describes the message protosprite.FrameGeometry.
 * Use `create(FrameGeometrySchema)` to create a new message.
 */
export const FrameGeometrySchema: GenMessage<FrameGeometry, {jsonType: FrameGeometryJson}> = /*@__PURE__*/
  messageDesc(file_sprite_geometry, 7);

/**
 * Top-level geometry container for one sprite.
 *
 * @generated from message protosprite.SpriteGeometryEntry
 */
export type SpriteGeometryEntry = Message<"protosprite.SpriteGeometryEntry"> & {
  /**
   * @generated from field: string sprite_name = 1;
   */
  spriteName: string;

  /**
   * @generated from field: repeated protosprite.FrameGeometry frames = 2;
   */
  frames: FrameGeometry[];

  /**
   * Simplification tolerance that was used to generate these polygons.
   *
   * @generated from field: float simplify_tolerance = 3;
   */
  simplifyTolerance: number;

  /**
   * De-duplicated shape pool. Frames reference shapes by index into this pool.
   *
   * @generated from field: repeated protosprite.ShapePoolEntry shape_pool = 4;
   */
  shapePool: ShapePoolEntry[];

  /**
   * De-duplicated vertex pool. ShapePoolEntry indices reference vertices here.
   *
   * @generated from field: repeated protosprite.Vec2 vertex_pool = 5;
   */
  vertexPool: Vec2[];
};

/**
 * Top-level geometry container for one sprite.
 *
 * @generated from message protosprite.SpriteGeometryEntry
 */
export type SpriteGeometryEntryJson = {
  /**
   * @generated from field: string sprite_name = 1;
   */
  spriteName?: string;

  /**
   * @generated from field: repeated protosprite.FrameGeometry frames = 2;
   */
  frames?: FrameGeometryJson[];

  /**
   * Simplification tolerance that was used to generate these polygons.
   *
   * @generated from field: float simplify_tolerance = 3;
   */
  simplifyTolerance?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * De-duplicated shape pool. Frames reference shapes by index into this pool.
   *
   * @generated from field: repeated protosprite.ShapePoolEntry shape_pool = 4;
   */
  shapePool?: ShapePoolEntryJson[];

  /**
   * De-duplicated vertex pool. ShapePoolEntry indices reference vertices here.
   *
   * @generated from field: repeated protosprite.Vec2 vertex_pool = 5;
   */
  vertexPool?: Vec2Json[];
};

/**
 * Describes the message protosprite.SpriteGeometryEntry.
 * Use `create(SpriteGeometryEntrySchema)` to create a new message.
 */
export const SpriteGeometryEntrySchema: GenMessage<SpriteGeometryEntry, {jsonType: SpriteGeometryEntryJson}> = /*@__PURE__*/
  messageDesc(file_sprite_geometry, 8);

/**
 * Root message serialized into .prsg files.
 *
 * @generated from message protosprite.SpriteGeometry
 */
export type SpriteGeometry = Message<"protosprite.SpriteGeometry"> & {
  /**
   * @generated from field: repeated protosprite.SpriteGeometryEntry entries = 1;
   */
  entries: SpriteGeometryEntry[];

  /**
   * The .prsg can either embed the full .prs data or reference it externally.
   *
   * @generated from oneof protosprite.SpriteGeometry.sprite_source
   */
  spriteSource: {
    /**
     * Full .prs binary embedded
     *
     * @generated from field: bytes embedded_prs = 2;
     */
    value: Uint8Array;
    case: "embeddedPrs";
  } | {
    /**
     * Path/filename of a .prs file
     *
     * @generated from field: string external_prs_file = 3;
     */
    value: string;
    case: "externalPrsFile";
  } | {
    /**
     * URL of a .prs file
     *
     * @generated from field: string external_prs_url = 4;
     */
    value: string;
    case: "externalPrsUrl";
  } | { case: undefined; value?: undefined };
};

/**
 * Root message serialized into .prsg files.
 *
 * @generated from message protosprite.SpriteGeometry
 */
export type SpriteGeometryJson = {
  /**
   * @generated from field: repeated protosprite.SpriteGeometryEntry entries = 1;
   */
  entries?: SpriteGeometryEntryJson[];

  /**
   * Full .prs binary embedded
   *
   * @generated from field: bytes embedded_prs = 2;
   */
  embeddedPrs?: string;

  /**
   * Path/filename of a .prs file
   *
   * @generated from field: string external_prs_file = 3;
   */
  externalPrsFile?: string;

  /**
   * URL of a .prs file
   *
   * @generated from field: string external_prs_url = 4;
   */
  externalPrsUrl?: string;
};

/**
 * Describes the message protosprite.SpriteGeometry.
 * Use `create(SpriteGeometrySchema)` to create a new message.
 */
export const SpriteGeometrySchema: GenMessage<SpriteGeometry, {jsonType: SpriteGeometryJson}> = /*@__PURE__*/
  messageDesc(file_sprite_geometry, 9);

